<template>
  <div class="reset-password">
    <div class="frow centered">
      <div v-if="passwordReset" class="box">
        Password has been reset, you will be redierected to the login page shortly.
      </div>
      <div v-else class="box">
        Enter your new password below.
        <p v-if="resetError" role="alert">{{ resetError }}</p>
        <label class="label">Password:</label>
          <input
          v-model="password"
          class="input"
          type="password"
          placeholder="Password"
        />
        <br />
        <br />
        <label class="label">Password Confirmation:</label>
          <input
          v-model="passwordConfirmation"
          class="input"
          type="password"
          placeholder="Password Confirmation"
        />
        <br />
        <br />
        <button
          class="button"
          :class="{'is-loading': resetingPassword}"
          :disabled="resetingPassword || password === '' || password !== passwordConfirmation"
          @click="resetPassword"
        >
          Reset Password
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  components: {},
  data() {
    return {
      password: '',
      passwordConfirmation: '',
      resetingPassword: false,
      passwordReset: false,
      resetError: '',
    };
  },
  computed: {
    API() {
      return this.$API;
    },
  },
  methods: {
    resetPassword() {
      if (this.resetingPassword) return;
      this.resetError = '';
      this.resetingPassword = true;
      this.axios
        .post(`${this.$API}/auth/reset-password`, {
          code: this.$route.query.code,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation,
        })
        .then(() => {
          this.resetingPassword = false;
          this.passwordReset = true;
          setTimeout(() => {
            this.$router.push('/login');
          }, 6000);
        })
        .catch(() => {
          this.resetingPassword = false;
          this.resetError = 'We could not reset your password. The link may have expired or already been used. Please request a new reset link.';
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.reset-password {
  background-color: #fff;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.box {
  height: 300px;
  width: 300px;
}
</style>
